<h2 mat-dialog-title class="dialog-header">
  <div class="header-left">
    <mat-icon class="header-icon">settings</mat-icon>
    USER SYSTEM INFO
  </div>
  <button type="button" aria-label="Close" (click)="onCancelClick()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<div class="field-wrapper" style="width: 250px;">
  <label class="aligned-label">SELECT YOUR SYSTEM</label>
  <mat-form-field appearance="fill" class="aligned-field">
    <mat-select name="system" placeholder="Select a System" (selectionChange)="changeSystem($event.value)">
      <mat-option [value]="null">Select a System</mat-option>
      <mat-option *ngFor="let system of systems" [value]="system">
        {{ system.systemName }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>